import { Dayjs } from 'dayjs';

/**
 * Computes the start/end of day (or week/month) boundaries for the "Jour",
 * "Semaine" and "Mois" modes. `date` must already be anchored on the
 * construction site timezone by the caller — this function only truncates,
 * it never converts a timezone. See `TemporalitySelectInput` for the two
 * anchoring strategies (instant-preserving `.tz()` for a "now"-derived
 * value, `.tz(undefined, true)` for a calendar-picked value).
 */
export const getSingleDateBounds = (
  date: Dayjs,
  unit: Parameters<Dayjs['startOf']>[0],
): [Dayjs, Dayjs] => [date.startOf(unit), date.endOf(unit)];

/**
 * Computes the start/end of day boundaries for the "Période" mode. `start`
 * and `end` must already be anchored on the construction site timezone by
 * the caller — see `getSingleDateBounds`.
 */
export const getPeriodBounds = (
  start: Dayjs | null | undefined,
  end: Dayjs | null | undefined,
): [Dayjs | undefined, Dayjs | undefined] => [
  start?.startOf('day'),
  end?.endOf('day'),
];
